document.addEventListener('DOMContentLoaded', async () => {
  console.log("→ DOM полностью загружен");

  let userGeolocation = localStorage.getItem('userGeolocation');

  async function getUserGeo() {
    if (userGeolocation) {
      console.log("📦 Геолокация из localStorage:", userGeolocation);
      return userGeolocation;
    }

    console.log("🌐 Запрашиваем геолокацию через IP API...");
    try {
      const response = await fetch("https://ipapi.co/json/?key=K03xOHk9lT8QTYh2jPTSWC3xlWRINTnl1411kyUjFwlWGHIYnE");
      const json = await response.json();
      console.log(json)
      userGeolocation = json.country_code;
      userGeolocationName = json.country_name;
      userGeolocationPostal = json.postal;
      localStorage.setItem('userGeolocationName', userGeolocationName);
      localStorage.setItem('userGeolocation', userGeolocation);
      localStorage.setItem('userPostCode', userGeolocationPostal);      
      console.log("🌎 Получено значение геолокации:", userGeolocation);
      console.log("🌎 Получено значение локации:", userGeolocationPostal);
      return userGeolocation;
    } catch (error) {
      console.error("❌ Ошибка получения геолокации:", error);
      return null;
    }
  }
getUserGeo();

});



// Функция для установки обработчиков событий на кнопки с классом .xsell-quick-add-to-cart
function setUpQuickAddToCartListeners() {
  const buttons = document.querySelectorAll('.xsell-quick-add-to-cart');

  if (buttons.length > 0) {
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        setTimeout(() => {
          const menuLists = document.querySelectorAll('.xsell-quick-add-to-cart-menu-list');
          if (menuLists.length > 0) {
            setUpMenuListListeners(menuLists);
          } else {
            const modalCloseButton = document.querySelector('.xsell__modal-close');
            if (modalCloseButton) {
              modalCloseButton.click();
            }
          }
        }, 4000);
      });
    });
  } else {
    // Если кнопки не найдены, повторяем проверку через 500 миллисекунд
    setTimeout(setUpQuickAddToCartListeners, 500);
  }
}

// Функция для установки обработчиков событий на элементы li внутри .xsell-quick-add-to-cart-menu-list
function setUpMenuListListeners(menuLists) {
  menuLists.forEach(menu => {
    const items = menu.querySelectorAll('li');
    items.forEach(item => {
      item.addEventListener('click', function() {
        // Обработка клика по li
        console.log('Item clicked:', item);
        // Имитация клика по кнопке .xsell__modal-close
        const modalCloseButton = document.querySelector('.xsell__modal-close');
        if (modalCloseButton) {
          setTimeout(() => {
            modalCloseButton.click();
          },4000)
        }
      });
    });
  });
}
setUpQuickAddToCartListeners();
